import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";

// Get Table Data
export const AssignedMaintainanceWorkTableDataAPI = createAsyncThunk("AssignedMaintainanceWorkTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_LocationID,
        M_WS_WorkTypeID,
        M_WS_WorkPeriodID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
        handleAssignedMaintainanceWorkExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url

    if (DashProjectTypeId == '6') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_AssginWaterMaintenanceServices_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_Distri_WorkTypeID=${M_WS_WorkTypeID ? M_WS_WorkTypeID : '0'}&M_Distri_WorkPeriodID=${M_WS_WorkPeriodID ? M_WS_WorkPeriodID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else if (DashProjectTypeId == '9') { 
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_TTP_AssginWaterMaintenanceServices_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_TTP_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_TTP_WorkTypeID=${M_WS_WorkTypeID ? M_WS_WorkTypeID : '0'}&M_TTP_WorkPeriodID=${M_WS_WorkPeriodID ? M_WS_WorkPeriodID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_AssignMaintenanceServices_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_WS_WorkTypeID=${M_WS_WorkTypeID ? M_WS_WorkTypeID : '0'}&M_WS_WorkPeriodID=${M_WS_WorkPeriodID ? M_WS_WorkPeriodID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleAssignedMaintainanceWorkExport && handleAssignedMaintainanceWorkExport()
                return result.data
            } else {
                return result
            }
        })
})

const AssignedMaintainanceWorkTableDataSlice = createSlice({
    name: "AssignedMaintainanceWorkTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(AssignedMaintainanceWorkTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(AssignedMaintainanceWorkTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(AssignedMaintainanceWorkTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const AssignedMaintainanceWorkTableDataReducer = AssignedMaintainanceWorkTableDataSlice.reducer



export const AssignedMaintainanceWorkTableExportDataAPI = createAsyncThunk("AssignedMaintainanceWorkTableExportData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_WS_LocationID,
        M_WS_WorkTypeID,
        M_WS_WorkPeriodID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url

    if (DashProjectTypeId == '6') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_AssginWaterMaintenanceServices_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_Distri_WorkTypeID=${M_WS_WorkTypeID ? M_WS_WorkTypeID : '0'}&M_Distri_WorkPeriodID=${M_WS_WorkPeriodID ? M_WS_WorkPeriodID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else if (DashProjectTypeId == '9') { 
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_TTP_AssginWaterMaintenanceServices_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_TTP_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_TTP_WorkTypeID=${M_WS_WorkTypeID ? M_WS_WorkTypeID : '0'}&M_TTP_WorkPeriodID=${M_WS_WorkPeriodID ? M_WS_WorkPeriodID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_AssignMaintenanceServices_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_LocationID=${M_WS_LocationID ? M_WS_LocationID : '0'}&M_WS_WorkTypeID=${M_WS_WorkTypeID ? M_WS_WorkTypeID : '0'}&M_WS_WorkPeriodID=${M_WS_WorkPeriodID ? M_WS_WorkPeriodID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const AssignedMaintainanceWorkTableExportDataSlice = createSlice({
    name: "AssignedMaintainanceWorkTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(AssignedMaintainanceWorkTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(AssignedMaintainanceWorkTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(AssignedMaintainanceWorkTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const AssignedMaintainanceWorkTableExportDataReducer = AssignedMaintainanceWorkTableExportDataSlice.reducer

// -----------------Delete API ---------------

export const AssignedMaintainanceWorkDeleteAPI = createAsyncThunk("AssignedMaintainanceWorkDelete", async ({ data }) => {
    const {
        T_WS_AssignMaintenanceServicesID,
        T_Distri_AssginWaterMaintenanceServicesID,
        T_TTP_AssginWaterMaintenanceServicesID, 
        M_UserID,
        token,
        handleIsPost,
        DashProjectTypeId
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6') {
        formdata.append("T_Distri_AssginWaterMaintenanceServicesID", T_Distri_AssginWaterMaintenanceServicesID);
    } else if (DashProjectTypeId == '9') {
        formdata.append("T_TTP_AssginWaterMaintenanceServicesID", T_TTP_AssginWaterMaintenanceServicesID);
    } else {
        formdata.append("T_WS_AssignMaintenanceServicesID", T_WS_AssignMaintenanceServicesID);
    }

    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6') {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_Distri_AssginWaterMaintenanceServices_Delete`
    } else if (DashProjectTypeId == '9') { 
        url = `${BaseUrl}/APKDashboard/WEB_T_TTP_AssginWaterMaintenanceServices_Delete`
    } else {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_WS_AssignMaintenanceServices_Delete`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const AssignedMaintainanceWorkDeleteSlice = createSlice({
    name: "AssignedMaintainanceWorkDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(AssignedMaintainanceWorkDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(AssignedMaintainanceWorkDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(AssignedMaintainanceWorkDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const AssignedMaintainanceWorkDeleteReducer = AssignedMaintainanceWorkDeleteSlice.reducer